import React, { useEffect, useState } from "react"
import { AdminIcons } from "../Shared/AdminIcon";
import { ThreeColumnContainer } from "../Shared/Formelements";
import { ScreenHeader } from "../UI/Elements"
import { Overlay } from "../UI/Overlay"
import { useAdAdmin, useAdClients } from "./useAdAdmin";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { EditDateKeyInput } from "../FormComponents/EditInput";
import { useDateHelper } from "../../hooks/useHelper";

export const SponsoredPushNotifications = () => {


    const ui = useSponsoredPushNotifications();

    const dh = useDateHelper();





    return (
        <div>
            <Overlay visible={false} />
            <ScreenHeader text="Pushnotiser" icon={AdminIcons.ad} />
            <div>
                <input type="checkbox" id="showdeleted" name="showdeleted" checked={ui.showDeleted} onChange={e => ui.setShowDeleted(e.target.checked)} />
                <label htmlFor="showdeleted">Visa raderade</label>
            </div>
            <div>
                {/* Klienter */}
                <table className="tbl">
                    <thead>
                        <tr>
                            <th>Namn</th>
                            <th>Title</th>
                            <th>Body</th>
                            <th>Link</th>
                            <th>Datekey (yyyymmdd)</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.data?.map(p => (
                            <tr key={p?.id}>
                                <td>
                                    {p?.name}
                                </td>
                                <td>{p?.title}</td>
                                <td>{p?.body}</td>
                                <td>{p?.link}</td>
                                <td>
                                    {(p?.state === "active" || p?.state === "deleted" || p?.state === "sending" || p?.state === "sent") && (
                                        <span>
                                            {p?.datekey}
                                        </span>
                                    )}
                                    {(p?.state === "draft") && (
                                        <EditDateKeyInput defaultValue={p?.datekey} onChange={e => ui.onUpdate(p?.id, { ...p, datekey: e })} />
                                    )}
                                </td>
                                <td>
                                    {(p?.state === "draft" || p?.state === "active" || p?.state === "deleted") && (<div>
                                        <StateSelect value={p?.state} onUpdate={newState => ui.onUpdate(p?.id, { ...p, state: newState })} />
                                    </div>)}

                                    {(p?.state === "sent" || p?.state === "sending") && (
                                        <div className="w250px text-small">
                                            State: {p?.state} <br />
                                            Start: {dh.epochToDateTime(p?.epoch_sending)} <br />
                                            End: {dh.epochToDateTime(p?.epoch_sent)} <br />
                                            Count: {p?.totalnumberofnotifications}
                                        </div>
                                    )}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <input type="text" value={ui?.model?.name ?? ""} onChange={e => ui.setModel({ name: e.target.value })} />
                            </td>
                            <td>
                                <input type="text" value={ui?.model?.title ?? ""} onChange={e => ui.setModel({ title: e.target.value })} />
                            </td>
                            <td>
                                <input type="text" value={ui?.model?.body ?? ""} onChange={e => ui.setModel({ body: e.target.value })} />
                            </td>
                            <td>
                                <input type="text" value={ui?.model?.link ?? ""} onChange={e => ui.setModel({ link: e.target.value })} />
                            </td>
                            <td>
                                <input type="text" value={ui?.model?.datekey ?? ""} onChange={e => {
                                    if (parseInt(e.target.value) > 0) {
                                        ui.setModel({ datekey: parseInt(e.target.value) });
                                    }
                                }} />
                            </td>
                            <td></td>
                            <td>
                                <button disabled={!ui.canAdd} className="btn" onClick={ui.onAdd}>Add</button>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </div>
    )
}

const StateSelect = ({ value, onUpdate }: { value: SponsoredPushNotificationStateType, onUpdate(e: SponsoredPushNotificationStateType): void }) => {

    const [editing, setEditing] = useState<boolean>(false);

    if (!editing) {
        return (
            <button onClick={() => setEditing(true)}>{value}</button>
        )
    }


    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
            <select value={value} onChange={e => {
                onUpdate(e.target.value as SponsoredPushNotificationStateType);
                setEditing(false);
            }}>
                <option value={"draft"}>draft</option>
                <option value={"active"}>active</option>
                <option value={"deleted"}>deleted</option>
                {/* <option value={"sent"}>sent</option> */}
            </select>
            <button onClick={() => setEditing(false)}>Stäng</button>
        </div>
    )
}

const useSponsoredPushNotifications = () => {


    const [rawData, setRawData] = useState<SponsoredPushNotificationType[]>([]);
    const [data, setData] = useState<SponsoredPushNotificationType[]>([]);
    const [model, setModel] = useState<SponsoredPushNotificationType>({});
    const [canAdd, setCanAdd] = useState<boolean>(false);
    const [showDeleted, setShowDeleted] = useState<boolean>(false);


    const load = async () => {
        let d: SponsoredPushNotificationType[] = await FetchHandler.getJson("/api/ads/push");
        d.sort((a, b) => {
            if (a?.datekey > b?.datekey) { return -1; }
            else if (a?.datekey < b?.datekey) { return 1; }
            else { return 0; }
        })
        setRawData(d);
        setData(d?.filter(m => showDeleted || m?.state !== "deleted"));
    }


    useEffect(() => {
        setCanAdd(
            model?.title?.length > 3 &&
            model?.body?.length > 3 &&
            model?.name?.length > 3 &&
            model?.datekey > 20250101
        );
    }, [model]);

    useEffect(() => {
        setData(rawData?.filter(m => showDeleted || m?.state !== "deleted"));
    }, [showDeleted])

    useEffect(() => {
        load();
    }, [])



    return {
        showDeleted: showDeleted, setShowDeleted: setShowDeleted,
        data: data,
        model: model ?? {},
        setModel: (e: SponsoredPushNotificationType) => {
            setModel({ ...(model ?? {}), ...e })
        },
        canAdd: canAdd,
        onAdd: async () => {
            if (canAdd) {
                const d = await FetchHandler.postJson("/api/ads/push/add", { ...model, state: "draft" });
                setModel(undefined);
                await load();
            }
        },
        onDelete: async (id: string) => {
            if (window.confirm("Radera?")) {
                const m = data.find(m => m.id == id);
                if (!!m) {
                    const d = await FetchHandler.patchJson("/api/ads/push/" + id + "/update", { ...m, state: "deleted" });
                    setModel(undefined);
                    await load();
                }
            }
        },
        onUpdate: async (id: string, model: SponsoredPushNotificationType) => {
            if (!!model) {
                const d = await FetchHandler.patchJson("/api/ads/push/" + id + "/update", model);
                setModel(undefined);
                await load();
            }
        },
    }



}

type SponsoredPushNotificationType = {
    id?: string,
    name?: string,
    title?: string,
    body?: string,
    link?: string,
    datekey?: number,
    state?: SponsoredPushNotificationStateType,
    epoch_sent?: number,
    epoch_sending?: number,
    totalnumberofnotifications?: number
}

type SponsoredPushNotificationStateType = "draft" | "deleted" | "active" | "sending" | "sent"